import { AxiosResponse } from "axios";
import HttpService from "src/services/httpService";
import RouteService from "src/services/routeService";
import { PaginatedResponse } from "src/types";

import { unpackError } from "@dashboard/devices/api/helpers";

export type FetchAllFdroidReposPayload = {
    workspaceId?: number;
    name?: string;
    title?: string;
    url?: string;
    pageIndex?: number;
    pageSize?: number;
    sortCriteria?: string;
    sortDirection?: 0 | 1;
};

export async function fetchAllFdroidRepos(
    payload: FetchAllFdroidReposPayload,
    signal?: AbortSignal,
): Promise<PaginatedResponse<API.FdroidRepoAdmin>> {
    try {
        const endpoint = await RouteService.getFdroidReposRoute();
        const response: AxiosResponse<PaginatedResponse<API.FdroidRepoAdmin>> = await HttpService.get(endpoint + "all", {
            params: {
                WorkspaceId: payload.workspaceId,
                Name: payload.name,
                Title: payload.title,
                Url: payload.url,
                PageIndex: payload.pageIndex,
                PageSize: payload.pageSize,
                SortCriteria: payload.sortCriteria,
                SortDirection: payload.sortDirection,
            },
            signal,
        });
        return response.data;
    } catch (error) {
        throw unpackError(error);
    }
}

export async function deleteFdroidRepo(id: number): Promise<{ message: string }> {
    try {
        const endpoint = await RouteService.getFdroidReposRoute();
        const response: AxiosResponse<{ message: string }> = await HttpService.delete(endpoint + String(id));
        return response.data;
    } catch (error) {
        throw unpackError(error);
    }
}
